import {ajax, find, findAll, findID, getDataAttributes, mergeDeepObject, removeElement, VGLog} from "../../../../../modules/vegas/js/util";
import VGMap from "./../maps/vgmap";
import {VGFormSender} from "vgformsender";

const VGModal = {
	isAdded: false,
	isInit: false,
	cross: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
		'\t viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">' +
		'<path d="M89.7,10.3L89.7,10.3c-1-1-2.6-1-3.5,0L50,46.5L13.9,10.3c-1-1-2.6-1-3.5,0l0,0c-1,1-1,2.6,0,3.5L46.5,50L10.3,86.1' +
		'\tc-1,1-1,2.6,0,3.5h0c1,1,2.6,1,3.5,0L50,53.5l36.1,36.1c1,1,2.6,1,3.5,0l0,0c1-1,1-2.6,0-3.5L53.5,50l36.1-36.1' +
		'\tC90.6,12.9,90.6,11.3,89.7,10.3z"/>' +
		'</svg>',

	init: function (modal, arg = {}) {
		if (!modal) {
			VGLog("error", ["Товарищ! Первый параметр не должен быть пустым!"]);
			return false;
		}

		let params = {
			cloned_content: 'false'
		}, dataParams = {};

		if (typeof modal === 'string') {
			params.modal = find(modal);
			if (params.modal) dataParams = getDataAttributes(params.modal);
		} else if (typeof modal === 'object') {
			let target = modal.dataset.target || modal.getAttribute('href') || null;

			if (!target) {
				VGLog("error", ["Мон Синьор! Путь к модалке не найден"]);
				return false;
			}
			params.modal = find(target);
			dataParams = getDataAttributes(modal);
		} else {
			VGLog("error", ["КЭП! Какая-то дичь к нам залетела"]);
			return false;
		}

		if (!params.modal) {
			VGLog("error", ["Сударь! А где, собственно, модалка?"]);
			return false;
		}

		params = mergeDeepObject(dataParams, params, arg);

		VGModal.isInit = true;
		VGModal.run(params);
	},

	run: function (params) {
		if (!VGModal.isInit) return false;

		let $modal = params.modal;

		let dParams = ['modal'];
		dParams.forEach((value) => { delete params[value]});

		for (let key in params) {
			let value = params[key];

			if (!VGModal.isAdded) {
				let $elements = $modal.querySelectorAll('[' + key + ']');
				for (let $tag of $elements) {
					if ($tag.tagName === 'INPUT' || $tag.tagName === 'TEXTAREA') {
						$tag.value = value;
					} else if ($tag.tagName === 'IMG') {
						$tag.setAttribute('src', value);
					} else if (key === 'data-action') {
						$tag.setAttribute('action', value);
					} else {
						$tag.textContent = value;
					}
				}
			}

			if (key === 'data-map') {
				VGModal.map(value, params);
				delete params['data-map'];
			}

			if(key === 'data-is-added') {
				VGModal.isAdded = true;
			}
		}

		VGModal.modalBootstrap($modal, params);
	},

	modalBootstrap: function ($modal, params) {
		if (!VGModal.isInit) return false;

		// Кнопка закрытия модалки
		let $modalBtnClose = find('.modal-close-block', $modal);
		if (!$modalBtnClose) {
			let div = document.createElement('div');
			div.className = "modal-close-block";

			let $content = find('.modal-content', $modal);
			div.innerHTML = '<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + VGModal.cross + '</button>';
			$content.prepend(div);
		} else {
			$modalBtnClose.innerHTML = '<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + VGModal.cross + '</button>';
		}

		if (!params.hasOwnProperty('data-bs-toggle')) {
			let modal = new Modal($modal, params);
			modal.show();

			if ('data-reload' in params) {
				$modal.addEventListener('hidden.bs.modal', function () {
					location.reload();
				});
			}
		}

		if ('data-route' in params && 'data-content' in params) {
			let $target = find(params['data-content']),
				route = params['data-route'];

			let deleteParams = [
				'cloned_container',
				'cloned_content',
				'data-content',
				'data-modal',
				'data-route',
				'data-target',
				'data-is-added',
				'data-bs-toggle',
				'data-vg-toggle'
			];

			for (let p in deleteParams) {
				delete params[deleteParams[p]];
			}

			for(let name in params) {
				let newName = name.replace('data-', '');
				params[newName] = params[name];
				delete params[name];
			}

			let modalPreload = find('.modal-preload', $modal);
			if (modalPreload) {
				modalPreload.style.display = 'block';
			}

			ajax.get(route, params, function(status, data) {
				setTimeout(() => {
					if (modalPreload) {
						modalPreload.style.display = 'none';
					}

					if ($target) {
						$target.innerHTML = data.view;
					}

					let $swipers = findAll('.swiper', $target);
					if ($swipers.length) {
						[...$swipers].map(($swiper) => {
							VGCarousel.init($swiper);
						});
					}

					let forms = findAll('[data-vgformsender]', $target);
					if(forms.length) {
						[...forms].map((form) => {
							new VGFormSender(form, {
								modal: bootstrap.Modal
							}).submit();
						})
					}
				}, 10);
			});
		}
	},

	map: function (id, params) {
		let map = findID(id);

		if (('data-lon' in params) && ('data-lat' in params)) {
			if (('data-lon' in params)) {
				map.setAttribute('data-lon', params['data-lon']);
				delete params['data-lon'];
			}
			if (('data-lat' in params)) {
				map.setAttribute('data-lat', params['data-lat']);
				delete params['data-lat'];
			}
		}

		if (map) {
			let $ymaps = find('ymaps', map);
			removeElement($ymaps)

			VGMap.init(id, {
				callback: {
					afterInitMap: function (map, params, _this) {
						VGMap.PlaceMark.set(map, params);
						VGMap.Map.offset(map, params);
					}
				}
			});
		}
	}
};

export default VGModal;
